<template>

    <portal to="body-content">
        <!-- Modal -->
        <div class="modal fade login-modal" id="loginModal" tabindex="-1" aria-labelledby="loginModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="loginModalLabel">Log In</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <svg class="close-2"><use xlink:href="#close-2"></use></svg>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form action="/login" @submit.prevent="submit">

                            <div class="form-row align-items-center mb-4">

                                <div class="col-sm-12 col-md-6 my-1">
                                    <input type="text"
                                           id="login-email"
                                           v-model="form.email"
                                           name="email"
                                           autocapitalize="off"
                                           placeholder="Enter Email/Username"
                                           aria-label="Enter Email or Username"
                                           class="form-control">
                                    <div class="error-message" v-if="form.errors.email" v-text="form.errors.email"></div>
                                </div>

                                <div class="col-sm-12 col-md-6 my-1">
                                    <input type="password"
                                           v-model="form.password"
                                           name="password"
                                           placeholder="Enter Password"
                                           aria-label="Enter Password"
                                           class="form-control">
                                    <div class="error-message" v-if="form.errors.password" v-text="form.errors.password"></div>
                                </div>

                            </div>

                            <button type="submit" class="btn-black" :class="{'disabled' : isDisabled}" :disabled="isDisabled" aria-label="Login Button">
                                Let's Go <svg class="arrow-right-2"><use xlink:href="#arrow-right-2"></use></svg>
                            </button>

                            <div class="form-divider">
                                <span>or</span>
                            </div>

                            <a :href="selectLoginUrl" class="btn-black button--select-login" aria-label="Login with Select">
                                <span>Login with</span>
                                <img src="/img/logo_with_select_white.png" alt="Select" class="select-logo">
                            </a>

                            <p class="alternative-text">
                                Forgot your <button @click="forgotPasswordModal()" type="button" aria-label="Forgot Password Button">password</button>?
                            </p>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </portal>

</template>
<script>

import EmailValidator from "email-validator";
import Form from '@/classes/Form'

export default {

    data() {
        return {
            form: new Form({
                email: '',
                password: '',
            }),
            redirectUrl: null,
        }
    },

    mounted() {
        $("#loginModal").on('shown.bs.modal', event => {
            $('#login-email').focus()
        })
        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        if(urlParams.has('login')) {
            this.$nextTick(() => {
                $("#loginModal").modal('show')
            })
        }
        if(urlParams.has('redirectUrl')) {
            this.redirectUrl = urlParams.get('redirectUrl')
        }
    },

    methods: {
        submit() {
            this.form.post('/login')
                .then(response => {
                    window.location.href = this.redirectUrl ? this.redirectUrl : '/home'
                })
        },

        forgotPasswordModal(){
            $('#loginModal').modal('toggle')
            $('#forgotPasswordModal').modal('toggle')
            // data-toggle="modal"
            // data-target="#forgotPasswordModal"
        }
    },

    computed:{
        isDisabled(){
            return this.form.isSubmitted;
            // return (this.form.email == '' || this.form.password == '' || !EmailValidator.validate(this.form.email))
        },
        selectLoginUrl() {
            const baseUrl = window.config?.selectBaseUrl || 'http://localhost:8081';
            return `${baseUrl}/auth/welltravel/login?product=welltravel`;
        },
    }
}
</script>
